import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core'
import { MenuItem } from 'primeng/api'
import { OverlayPanel } from 'primeng/overlaypanel'
import { BehaviorSubject, Observable } from 'rxjs'

@Component({
  selector: 'basin-searchbox',
  templateUrl: './searchbox.component.html',
  styleUrls: ['./searchbox.component.scss'],
})
export class SearchboxComponent {
  @Input() searchString: string
  @Output() searchStringChange = new EventEmitter<string>()
  @Output() chipFiltersChange = new EventEmitter<string[]>()
  @Output() activeChipFiltersChange = new EventEmitter<string[]>()
  @Output() searchEntered = new EventEmitter<string>()
  @Input() placeholder: string = 'Search...'
  @Input() width: string = '100%'
  @Input() resultsMaxHeight: string = '184px'
  @Input() disabled: boolean = false
  @Input() multiple: boolean = false
  @Input() chipFilterOnly: boolean = false
  @Input() searchResultDropdown: boolean = false
  @Input() toggleableFilterChips: boolean
  @ViewChild('searchInput') searchInput: ElementRef

  private _searchResults: Observable<MenuItem[]>
  @Input() set searchResults(v: MenuItem[] | Observable<MenuItem[]>) {
    if (Array.isArray(v)) {
      this.getResults(v)
    } else {
      if (this._searchResults) return

      this._searchResults = v
      this._searchResults.subscribe((v) => this.getResults(v))
    }
  }

  @Input() noSearchResultsFoundLabel: string = 'No results found'
  @Input() searchResultsLoading: boolean = false

  /** unique list of strings to output */
  filterChips: Set<string> = new Set<string>()
  activeFilterChips: Set<string> = new Set<string>()

  searchChange(event) {
    this.searchString = event
    this.announceSearchChange()
  }

  clearSearch() {
    this.searchString = ''
    this.announceSearchChange()
  }

  enterSearch() {
    if (
      this.multiple &&
      this.searchString.length > 0 &&
      this.searchString.trim() != ''
    ) {
      this.filterChips.add(this.searchString.trim())
      this.activeFilterChips.add(this.searchString.trim())
    }
    this.searchEntered.emit(this.searchString)
    this.announceSearchChange()
    if (this.multiple) {
      this.searchString = ''
    }
    this.searchInput.nativeElement.focus()
  }

  announceSearchChange() {
    if (this.multiple) {
      this.chipFiltersChange.emit([
        this.chipFilterOnly ? '' : this.searchString,
        ...this.filterChips,
      ])
      this.activeChipFiltersChange.emit([
        this.chipFilterOnly ? '' : this.searchString,
        ...this.activeFilterChips,
      ])
    }
    this.searchStringChange.emit(this.searchString)
  }

  checkIfActive(filterChip: string) {
    if (this.toggleableFilterChips)
      return this.activeFilterChips.has(filterChip)
    return true
  }

  turnOffChipFilter(active, filterChip: string) {
    if (active) {
      this.activeFilterChips.add(filterChip)
    } else {
      this.activeFilterChips.delete(filterChip)
    }
    this.announceSearchChange()
  }

  removedChip(chip: string) {
    this.filterChips.delete(chip)
    this.announceSearchChange()
  }

  //#region searchbox
  @ViewChild('searchPanel', { static: true }) searchPanel!: OverlayPanel
  @ViewChild('searchResultsPanel', { static: true })
  searchResultsPanel!: ElementRef

  selectResultFromOverlay(item: MenuItem) {
    this.searchString = item.label
    this.enterSearch()
    this.searchPanel.hide()
  }

  resultView$: BehaviorSubject<MenuItem[]> = new BehaviorSubject<MenuItem[]>([])

  getResults(results: MenuItem[]) {
    if (!this.searchResultDropdown) return

    this.resultView$.next(results)

    if (this.searchString?.length > 0) {
      this.searchPanel.show(null, this.searchResultsPanel.nativeElement)
    }
  }
  //#endregion

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Home' || event.key === 'End') {
      event.stopPropagation()
    }
  }
}
